import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { type ICompanyProgramItem } from '@/app/types/dmsTypes'
import { Loader } from '@/shared'

import { emptyProgram } from '../../helper'
import { EmptyContent } from '../EmptyContent/EmptyContent'
import { GoBack } from '../GoBack/GoBack'

import { Item } from './Item/Item'
import style from './Programs.module.scss'

export const Programs = observer(() => {
    const { companyId, contractId } = useParams()
    const navi = useNavigate()

    const [newProgram, setNewProgram] = useState<ICompanyProgramItem | null>(null)

    useEffect(() => {
        if (contractId && !dmsState.companyPrograms) {
            dmsState.onGetCompanyPrograms(contractId)
        }
        return () => {
            dmsState.onSetCompanyPrograms(null)
        }
    }, [contractId])

    if (!dmsState.companyPrograms) {
        return <Loader />
    }

    if (!companyId || !contractId) {
        return null
    }

    const onAddNewItem = () => {
        setNewProgram(emptyProgram)
    }

    const onHandleGoBack = () => navi(-1)

    if (dmsState.companyPrograms.data.length === 0 && !newProgram) {
        return (
            <>
                <GoBack onGoBack={onHandleGoBack} />
                <EmptyContent
                    title='Список программ пуст'
                    action={{
                        title: 'Добавить первую программу',
                        callback: onAddNewItem
                    }}
                />
            </>
        )
    }

    return (
        <div className={style.container}>
            {!newProgram && (
                <div className={style.addProgram}>
                    <button className={style.btn} onClick={onAddNewItem}>
                        Добавить Программу
                    </button>
                </div>
            )}
            <GoBack onGoBack={onHandleGoBack} />
            {newProgram && (
                <Item {...newProgram} mode='add' contractId={contractId} onZeroNewProgram={() => setNewProgram(null)} />
            )}
            {!newProgram &&
                dmsState.companyPrograms.data.map((program) => {
                    const { id } = program
                    return <Item key={id} mode='change' contractId={contractId} {...program} />
                })}
        </div>
    )
})
